/**
 * Created by Administrator on 2018/3/5 0005.
 */
/* eslint-disable */
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'



// WEBPACK FOOTER //
// ./src/vendors/vendor.js